import { useEffect, useState } from 'react';
import axios from 'axios';
import { BookOpen, Download, Eye } from 'lucide-react';
import { ouvrirPdf } from '../reglement-interieur/SignerReglementDialog';

const BTN = 'inline-flex items-center gap-1.5 rounded-lg bg-white px-3 py-1.5 text-xs font-semibold text-sky-700 ring-1 ring-sky-200 transition-colors hover:bg-sky-100';

// Espace candidat : livret d'accueil consultable dès l'inscription (s'il est publié)
export const TuileLivretCandidat = () => {
  const [publie, setPublie] = useState(false);
  useEffect(() => { axios.get('/livret-accueil/disponible').then(({ data }) => setPublie(data.publie)).catch(() => {}); }, []);
  if (!publie) return null;
  return (
    <div className="flex flex-wrap items-center gap-4 rounded-xl border border-sky-200 bg-sky-50 p-4 text-sky-900" data-testid="livret-carte-candidat">
      <div className="rounded-lg bg-white/70 p-2"><BookOpen className="h-5 w-5" /></div>
      <div className="min-w-[200px] flex-1">
        <p className="font-semibold">Livret d'accueil FISL</p>
        <p className="text-xs opacity-80">Le centre, l'équipe, la formation, les épreuves, les infos pratiques, vos droits et vos engagements</p>
      </div>
      <div className="flex gap-2">
        <button type="button" onClick={() => ouvrirPdf('/livret-accueil/pdf', 'Livret_accueil_FISL.pdf')} className={BTN} data-testid="livret-consulter-candidat"><Eye className="h-3.5 w-3.5" /> Consulter</button>
        <button type="button" onClick={() => ouvrirPdf('/livret-accueil/pdf', 'Livret_accueil_FISL.pdf', 'download')} className={BTN} data-testid="livret-telecharger-candidat"><Download className="h-3.5 w-3.5" /> Télécharger</button>
      </div>
    </div>
  );
};
